/**
 * Error logging utility for application errors
 * Future-ready for integration with Application Insights or Sentry
 */

import React from 'react'

/**
 * Logs error information to console with formatting
 * In production, this would be extended to send errors to a logging service
 */
export function logError(error: Error, errorInfo: React.ErrorInfo): void {
  const timestamp = new Date().toISOString()
  const isDevelopment = import.meta.env.DEV

  if (isDevelopment) {
    // Detailed logging in development
    console.group(`🔴 Error caught at ${timestamp}`)
    console.error('Error:', error)
    console.error('Error message:', error.message)
    console.error('Error stack:', error.stack)
    console.error('Component stack:', errorInfo.componentStack)
    console.groupEnd()
  } else {
    // Minimal logging in production
    console.error('Application error:', error.message)
  }

  // Future integration point for error tracking services
  // Example: Application Insights, Sentry, etc.
  // trackError({
  //   error,
  //   errorInfo,
  //   timestamp,
  //   userAgent: navigator.userAgent,
  //   url: window.location.href,
  // })
}

/**
 * Formats error information for display
 */
export function formatErrorInfo(error: Error, errorInfo: React.ErrorInfo): string {
  return `${error.toString()}\n\nComponent Stack:${errorInfo.componentStack}`
}
